import { css } from '@emotion/react';

export default $ => css`
  .array-item.for-object-row.denied,
  .array-item.panel-row.denied {
    background-color: ${$.white};
  }

  .array-item.for-object-row.superseded,
  .array-item.panel-row.superseded {
    background-color: ${$.gray100};
  }

  .uweentity-form.form-component.hide-card-body {
    .form-component-fields > .form-component {
      margin-right: 0;
      margin-left: 0;

      > .card {
        border: none;

        > .card-body {
          padding-top: 12px;
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .form-component .card-footer-container {
    background: white;
    padding-bottom: 8px;
  }

  .uweentity-form.form-component {
    min-width: 0;

    &:has(.form-sticky-header) {
      .card-body {
        padding-top: 0 !important;
      }
    }

    > .form-sticky-header {
      position: sticky;
      top: ${$.navbarHeight};
      z-index: 100;
    }

    .card > .card-footer {
      background-color: ${$.white};
      border-top: none;

      &.form-card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: white;
        gap: 12px;
      }
    }

    .card > .card-footer-container {
      background: white;
      .form-card-footer {
        background: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }
    }
  }

  .form-card-footer {
    background-color: white;
    padding-bottom: 4px;
  }

  .uweentity-form.form-component {
    > .form-sticky-header > .uweentity-title {
      position: relative;
      position: relative;
      background-color: rgba(248, 250, 255);
      font-size: 15px;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      padding: 5px 16px;
      font-weight: 500;

      @media (max-width: 768px) {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
      }

      > .btn-bar {
        position: absolute;
        right: 18px;
        top: 7px;

        > .btn {
          margin-left: 5px;
        }
      }

      > .cancel-btn {
        position: absolute;
        right: 18px;
      }
    }

    > .form-component,
    > .form-component-fields > .form-component,
    > .sp-form-body > .form-component-fields > .form-component {
      // margin-left: 18px;
      // margin-right: 18px;

      > .card {
        border: none;

        legend[id^='root_'][id$='__title'] {
          border-radius: 15px;
        }
      }
    }
  }

  .uweentity-form-full-expanded-sidepanel {
    border-bottom: 0px;
    border-left: 0px;
    border-right: 0px;
    padding: 7px;

    ul.striped-list {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    ul.striped-list > li {
      border-bottom: 1px solid ${$.gray100};
      padding: 6px;
      padding-top: 15px;
      padding-bottom: 15px;
    }

    ul.striped-list > li:nth-of-type(odd) {
      background-color: ${$.gray200};
    }

    ul.striped-list > li:last-child {
      border-bottom: none;
    }

    .card-header {
      position: relative;
      font-size: 1.45rem;
      padding-top: 4px;
      font-weight: bold;
      padding-left: 9px;
      padding-bottom: 0;
    }

    .btn-bar {
      > .btn {
        position: relative;
        right: auto;
        top: auto;
        border-radius: 8px;
        width: 24px;
        min-width: auto;
        max-width: auto;
        padding: 0;
        height: 24px;
        margin-left: 12px;
        .fa {
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`;
